<template>
  <div style="width: 160px" class="pa-4 pt-0">
    <h1>{{ value }}</h1>
    <span>{{ name }}</span>
  </div>
</template>

<script>
export default {
  props: ["name", "value"],
};
</script>